module.exports = __webpack_public_path__ + "static/img/yeswecan0003.bf0a46e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/yeswecan0003.png
// module id = 569
// module chunks = 1